
import { IAnonymousPageObjectTreeService } from "./anonymous-page-object-tree";
import { PageObjectTreeService } from "../page-object-tree.service";
import { LocalStorageKeyEnum } from "@modules/main/LocalStorageKeyEnum";

// TODO: AnonymousPageObjectTreeService方法实现
export abstract class AnonymousPageObjectTreeService extends PageObjectTreeService implements IAnonymousPageObjectTreeService {

    constructor() {
        super();
    }

    setAnonymous(isAnonymous: boolean, anonymousUserId?: string) {
        this.setCache(LocalStorageKeyEnum.IS_ANONYMOUS, isAnonymous.toString());

        if (anonymousUserId) {
            this.setCache(LocalStorageKeyEnum.ANONYMOUS_USER_ID, anonymousUserId);
        }
    }

}